export default {
    USER_TYPE: 'userType',
    HAS_VEHICLE_IN_GARAGE: 'hasVehicleInGarage',
    IS_LOGGEDIN: 'isLoggedIn',
    ECOMMERCE_GARAGE: 'eCommerceGarage',
    ECOMMERCE_FINANCE: 'eCommerceFinance',
    ECOMMERCE_TRADEIN: 'eCommerceTradeIn',
};
